<script setup lang="ts">
import NotFound from '@/components/shared/NotFound.vue'
import LayoutRootPage from '@/components/shared/LayoutRootPage.vue'
</script>

<template>
  <LayoutRootPage>
    <template #page-content>
      <NotFound class="not-found" />
    </template>
  </LayoutRootPage>
</template>
